import React from "react";
import { Image } from "../ui/Image";

const Banner = ({ style }) => {
  return (
    <div className={style.banner}>
      <div className={style.left}>
        <h2>
          Welcome to <span className={style.logoName}>Hopa</span> Vitamins
        </h2>
        <p>
          At Hopa Vitamins, we believe in empowering your health with the finest
          quality vitamins.
        </p>
      </div>
      <Image className={style.middle} img="vitC-kids" desc={"Vitamin C Kids"} />
    </div>
  );
};

export default Banner;
